export const MODAL_OFFSET_X = 5;
export const MODAL_OFFSET_Y = 15;
